/* eslint-disable max-lines-per-function */
import { store } from "jiffy-store";

export default {
  selectors: {
    productDetails: ".js-product-details",
    actualPrice: ".js-product-details-quantity-form-row-amount",
    productGridForm: "#product-grid-form",
    productDetailsVariantsForm: "#product-details-variants-form",
    formEventId: "#form-event-id",
    orderReference: "div.js-order-number-container",
    productReference: "div#product-page-container"
  },
  checkVariantPricesInterval: null,
  variantPricesData: null,
  variantPricesCountData: null,
  variantPrintAreaPrice: null,
  variantRetailPrices: null,
  lineItems: {},
  originalVariantPricesCountData: null,
  projectColor: null,
  decorationPricesForVariants: {},
  variantDomStructure: {
    ready: false,
    fetched: false,
    domLoaded: false
  },

  loadPrices(data) {
    if (data.variant_prices) {
      this.variantPricesData = data.variant_prices;
    }
    if (data.decoration_prices_for_variants) {
      this.decorationPricesForVariants = data.decoration_prices_for_variants;
    }
    if (data.variant_prices_count) {
      this.variantPricesCountData = data.variant_prices_count;
      this.originalVariantPricesCountData = { ...data.variant_prices_count };
    }

    if (data.print_area_prices) {
      this.variantPrintAreaPrice = data.print_area_prices;
    }

    if (data.retail_prices) {
      this.variantRetailPrices = data.retail_prices;
    }

    this.projectColor = data.project_color;
    this.variantDomStructure.fetched = true;
    this.cacheVariantDom();
    this.updateVariantPricesData();
  },

  variantPricesDataLoadPromise() {
    return new Promise(resolve => {
      clearInterval(this.checkVariantPricesInterval);

      this.checkVariantPricesInterval = setInterval(() => {
        const dataReady =
          (this.variantPricesData || this.variantPricesCountData) && this.variantDomStructure.ready;

        if (!dataReady) {
          return;
        }

        resolve();
        clearInterval(this.checkVariantPricesInterval);
      }, 1000);
    });
  },

  cacheVariantDom() {
    if (
      !(
        this.variantDomStructure.domLoaded &&
        this.variantDomStructure.fetched &&
        (this.variantPricesData || this.variantPricesCountData)
      )
    ) {
      return;
    }

    this.cacheMobileGridDom();

    this.variantDomStructure.ready = true;
  },

  cacheMobileGridDom() {
    const mobileGridForm = document.getElementById("product-details-quantity-form");
    if (!mobileGridForm) return;
    const productDetailsQuantityForm = [];

    mobileGridForm
      .querySelectorAll("input[name^='variants['][name$='][quantity]']")
      .forEach(input => {
        const variantId = parseInt(input.name.match(/variants\[(\d+)\]\[quantity\]/)[1], 10);
        productDetailsQuantityForm[variantId] = {
          input,
          priceElement: input
            .closest(".js-product-details-quantity-form-row-item")
            .querySelector(this.selectors.actualPrice)
        };
        const percentOffElement = input
          ?.closest(".js-product-details-quantity-form-row-item")
          ?.querySelector(".js-product-details-quantity-form-row-percent-off")
          ?.querySelector(".js-percent-off");
        if (percentOffElement) {
          productDetailsQuantityForm[variantId].percentOffElement = percentOffElement;
        }
        const savingOffElement = input
          ?.closest(".js-product-details-quantity-form-row-item")
          ?.querySelector(".js-product-details-quantity-form-row-percent-off")
          ?.querySelector(".js-saving-off");
        if (savingOffElement) {
          productDetailsQuantityForm[variantId].savingOffElement = savingOffElement;
        }
        const msrpElement = input
          ?.closest(".js-product-details-quantity-form-row-item")
          ?.querySelector(".retail-amount");
        if (msrpElement) {
          productDetailsQuantityForm[variantId].msrpElement = msrpElement;
          productDetailsQuantityForm[variantId].msrp = parseFloat(
            $(msrpElement)
              .text()
              .replace(/[^\d.]*/g, "")
          );
        }
      });

    store.pdp.change({ productDetailsQuantityForm });
  },

  getOrderReference() {
    const $orderRef = document.querySelector(this.selectors.orderReference);
    return $orderRef ? $orderRef.getAttribute("data-order-number") : "";
  },

  resetEventId() {
    const orderReference = this.getOrderReference();
    const $productRef = document.querySelector(this.selectors.productReference);
    const productReference = $productRef ? $productRef.getAttribute("data-product-id") : "";

    document.querySelector(this.selectors.formEventId).value = [
      orderReference,
      Math.round(Date.now() / 1000),
      productReference
    ].join(":");
  },

  updateVariantPricesData() {
    if (this.originalVariantPricesCountData) {
      const filteredList = Object.keys(this.lineItems).filter(
        id => this.originalVariantPricesCountData[id]
      );

      filteredList.forEach(id => {
        const variant = this.originalVariantPricesCountData[id];
        const newVariant = {};
        const addedCount = this.lineItems[id];
        const variantKeys = Object.keys(variant);

        for (let i = 0; i < variantKeys.length; i += 1) {
          const variantPosition = variantKeys[i];
          const shiftDiscountPosition = variantPosition - addedCount;
          newVariant[shiftDiscountPosition] = variant[variantPosition];
        }

        this.variantPricesCountData[id] = newVariant;
      });
    }
  },

  setLineItems(lineItems) {
    this.lineItems = lineItems;
    this.updateVariantPricesData();
  },

  initLineItems() {
    const $productDetails = document.querySelector(this.selectors.productDetails);
    const { lineItems } = $productDetails?.dataset || {};
    this.setLineItems(lineItems);
  }
};
